import '@szhsin/react-menu/dist/index.css';
import '@szhsin/react-menu/dist/transitions/slide.css';
import React, { CSSProperties, useState } from 'react';
import { Menu, MenuItem, MenuProps } from '@szhsin/react-menu';
import { themeState } from 'styleguide/theme';
import { observer } from 'mobx-react-lite';
import { CornerRadius, Spacing } from 'styleguide/spacing';
import { P2 } from 'styleguide/Texts';
import { Icon, IconType } from 'styleguide/Icons';
import { colors } from 'styleguide/colors';

export const HevyMenu = observer(({ menuStyle, ...props }: MenuProps) => (
  <Menu
    {...props}
    position="auto"
    overflow="auto"
    portal={true}
    viewScroll="close"
    menuStyle={{
      borderRadius: CornerRadius.md,
      border: `1px solid ${
        themeState.current.name === 'light' ? colors.greyUltraLight : colors.greyDark
      }`,
      backgroundColor: themeState.current.name === 'light' ? colors.white : colors.greyHiperDark,
      boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.08)',
      ...menuStyle,
    }}
    transition={true}
  >
    {props.children}
  </Menu>
));

interface HevyMenuItemProps {
  title: string;
  iconType?: IconType;
  onClick: () => void;
  tint?: string;
  iconStyle?: CSSProperties;
  textStyle?: CSSProperties;
}

export const HevyMenuItem = (props: HevyMenuItemProps) => {
  const hoverBackgroundColor =
    themeState.current.name === 'light' ? colors.greyLight : colors.greyDark;
  const [isHovering, setIsHovering] = useState(false);
  const iconTint = props.tint ?? themeState.current.primary;

  return (
    <MenuItem
      onClick={props.onClick}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
      style={{ background: isHovering ? hoverBackgroundColor : undefined }}
    >
      {props.iconType && (
        <Icon
          style={{ marginInlineStart: -Spacing.sm, ...props.iconStyle }}
          type={props.iconType}
          tint={iconTint}
        />
      )}
      <P2 style={{ marginInlineStart: Spacing.sm, ...props.textStyle }}>{props.title}</P2>
    </MenuItem>
  );
};

export const HevyOptionMenu = (props: { children: React.ReactNode; style?: CSSProperties }) => {
  return (
    <HevyMenu
      menuButton={
        <div
          style={{
            display: 'flex',
            cursor: 'pointer',
            justifyContent: 'center',
            ...props.style,
          }}
          onClick={e => {
            e.stopPropagation();
            e.preventDefault();
          }}
        >
          <div style={{ cursor: 'pointer', padding: Spacing.sm }}>
            <Icon type="vertical-dots" />
          </div>
        </div>
      }
      onItemClick={e => {
        e.syntheticEvent.stopPropagation();
        e.syntheticEvent.preventDefault();
      }}
    >
      {props.children}
    </HevyMenu>
  );
};
